import { handleActions } from 'redux-actions';
import * as types from '../constants/Package';
import * as sectionReducerUtils from '../utilities/section/sectionReducerUtils';

const packageHandler = (state, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.PACKAGE_INITIAL:
      return sectionReducerUtils.getInitialState(state.packageData);
    case types.PACKAGE_REQUEST:
      return sectionReducerUtils.getRequestState(state);
    case types.PACKAGE_RECEIVE:
      return sectionReducerUtils.getReceiveState(state, action);
    case types.PACKAGE_UPDATE:
      return sectionReducerUtils.setPackageUpdate(state, payload);
    case types.SECTION_NEXT:
      return sectionReducerUtils.nextSection(state, payload);
    case types.PAGE_NEXT:
      return sectionReducerUtils.nextPage(state, payload);
    case types.STEP_NEXT:
      return sectionReducerUtils.nextStep(state, payload);
    case types.STEP_PREV:
      return sectionReducerUtils.prevStep(state, payload);
    case types.ELEMENT_TOGGLE:
      return sectionReducerUtils.elementToggle(action, state);
    default:
      return {};
  }
};

const Section = handleActions({
  [types.PACKAGE_INITIAL]: (state, action) => ({
    ...state,
    ...packageHandler(state, action),
  }),
  [types.PACKAGE_REQUEST]: (state, action) => ({
    ...state,
    ...packageHandler(state, action),
  }),
  [types.PACKAGE_RECEIVE]: (state, action) => ({
    ...state,
    ...packageHandler(state, action),
  }),
  [types.PACKAGE_UPDATE]: (state, action) => ({
    ...state,
    ...packageHandler(state, action),
  }),
  [types.SECTION_NEXT]: (state, action) => ({
    ...state,
    ...packageHandler(state, action),
  }),
  [types.PAGE_NEXT]: (state, action) => ({
    ...state,
    ...packageHandler(state, action),
  }),
  [types.STEP_NEXT]: (state, action) => ({
    ...state,
    ...packageHandler(state, action),
  }),
  [types.STEP_PREV]: (state, action) => ({
    ...state,
    ...packageHandler(state, action),
  }),
  [types.ELEMENT_TOGGLE]: (state, action) => ({
    ...state,
    ...packageHandler(state, action),
  }),
}, sectionReducerUtils.getEmptyState());

export default Section;



// WEBPACK FOOTER //
// ./src/reducers/Section.js